import { DocumentDownloadIcon, VideoPlayIcon } from "assets/icons";
import cn from "classnames";
import { MediaType } from "constants/enums";
import { memo, useEffect, useRef, useState } from "react";

import { MediaProps } from "./Media.types";

import styles from "./Media.module.scss";

const Media = ({
  mediaFile,
  className,
  style,
  withVideoLabel = false,
  onClick,
  mediaClassName,
  ...rest
}: MediaProps) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  const [isVideoFullscreen, setIsVideoFullscreen] = useState(false);

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsVideoFullscreen(document.fullscreenElement === videoRef.current);
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, [videoRef.current]);

  return (
    <div className={cn(styles.mediaContainer, className)} style={style}>
      {mediaFile.mediaType === MediaType.VIDEO ? (
        <>
          <video
            ref={videoRef}
            onClick={onClick}
            className={cn(styles.media, mediaClassName, {
              [styles.video_fullscreen]: isVideoFullscreen
            })}
            src={mediaFile.url}
            {...rest}
          />

          {withVideoLabel && <VideoPlayIcon className={styles.playVideoIcon} />}
        </>
      ) : mediaFile.mediaType === MediaType.IMAGE ? (
        <img
          onClick={onClick}
          className={cn(styles.media, mediaClassName)}
          src={mediaFile.url}
        />
      ) : (
        <a
          href={mediaFile.url}
          target="_blank"
          rel="noreferrer"
          onClick={onClick}
          className={cn(styles.document)}
        >
          <DocumentDownloadIcon className={cn(styles.document_icon)} />
          <span className={styles.document_name}>{mediaFile.fileName}</span>
        </a>
      )}
    </div>
  );
};

export default memo(Media);
